<template>
    <div class="app-container" :class="{'scroll-disabled': $store.getters.disableScroll}">
        <HeaderSection v-if="isTokenSet" :form-builder="formBuilder"
                       @close-form="closeForm"
                       @add-component-clicked="addComponentClicked"
        />

        <Spinner v-if="loading" style="margin-top: 25vh; margin-bottom: 25vh;"/>

        <router-view v-else

                     @add-component-clicked="addComponentClicked"
                     @add-host-gifts-clicked="addHostGiftsClicked"
                     @add-elevated-host-gifts-clicked="addElevatedHostGiftsClicked"
                     @add-party-clicked-from-calendar="addPartyClickedFromCalendar"
                     @add-demo-clicked="addDemoClicked"
                     @add-profiling-clicked="addProfilingClicked"
        />

        <AddEntityButton v-if="isTokenSet && $route.name == 'Dashboard'" @add-component-clicked="addComponentClicked"/>
        <!-- <FooterMenu v-if="isTokenSet" @menu-item-clicked="menuItemClicked"/> -->
        <FullScreenContainer/>
        <DialogContainer/>        
        <Notifications v-if="$route.name == 'never'" />
    </div>
</template>

<script>
 import * as types from '@/store/mutations'
 import HeaderSection from "./components/core/HeaderSection.vue";
 import Notifications from "./components/core/Notifications.vue";
 import DialogContainer from "./components/core/DialogContainer.vue";
 import FullScreenContainer from "./components/core/FullScreenContainer.vue";
 // import FooterMenu from "./components/core/FooterMenu.vue"
 import { ref } from 'vue'
 import { useRouter } from  'vue-router'
 import { useStore } from 'vuex'
 import AddEntityButton from "./components/core/AddEntityButton.vue";
 import Spinner from "@/components/core/Spinner.vue";
 import moment from 'moment'
 import 'moment/locale/nb'
 import 'moment/locale/sv'
 import 'moment/locale/fi'
 import * as constants from '@/store/constants'

 export default {
     name: 'App',
     data(){ return {
         loading: true
     }},
     components: {
         AddEntityButton,
         HeaderSection,
         // FooterMenu,
         Spinner,
         Notifications,
         DialogContainer,
         FullScreenContainer
     },
     computed: {
         isTokenSet () {
             return this.$store.getters.isTokenSet
         },
         isDevMode () {
             return window.localStorage.getItem('isDevEnv')
         }
     },

     async created(){
         let cdnurl = process.env.VUE_APP_CDN_URL
         if (cdnurl?.length < 10){
             cdnurl = 'https://cdn2.perfecthome.com/'
         }


         document.title = 'Perfect Home'
         console.log('using ' + process.env.VUE_APP_API_URL + ' and ' + cdnurl)
         window.localStorage.setItem('baseUrl',process.env.VUE_APP_API_URL)
         window.localStorage.setItem('cdnUrl',cdnurl)
         window.localStorage.setItem('isDevEnv',process.env.VUE_APP_IS_DEBUG_MODE === "true")
         window.localStorage.removeItem('postCache')
         window.localStorage.removeItem('postCacheLifetime')
        try{
            await this.$store.dispatch('reauth',{i18n:this.$i18n, moment:moment}).catch(err => {
              this.$store.dispatch('loadOptionsMap')
              console.log('App.created -> reauth failed:', err)
              this.$router.push({name: 'Login'})
            })
          } catch (e){
            this.$router.push({name: 'Login'})
          }

         this.loading = false
     },
     setup() {
         const router = useRouter()
         const store = useStore()

         router.afterEach(()=>{
             store.commit(types.CLOSE_MENU)
         })

         const formBuilder = ref({
             formOpen:false,
             entityType:'customer',
             entityReference:-1
         })

         const closeForm = () => {
             formBuilder.value.formOpen = false

             // also potential leftover pages if a form
             // and its helper pages (filter) were closed
             // by clicking on the background
             // TODO: close only the current layer if clicked on the background
             // TODO: ask for confirmation if users has unsaved work
             store.commit(types.CLOSE_FILTERPAGE)
             store.commit(types.UPDATE_CUSTOM_POPUP_STATE, false)
         }

         // const menuItemClicked = (route) =>{
         //     window.scrollTo(0,0);
         //     router.push({name:route})
         // }

         const addHostGiftsClicked = (type,refValue = -1) =>{
             //console.log("addHostGiftsClicked", type, refValue)
             formBuilder.value.formOpen = true
             formBuilder.value.entityType = type
             formBuilder.value.entityReference = refValue
             formBuilder.value.line_type = constants.LINE_HOST_GIFT
         }

         const addElevatedHostGiftsClicked = (type,refValue = -1) =>{
             //console.log("addElevatedHostGiftsClicked", type, refValue)
             formBuilder.value.formOpen = true
             formBuilder.value.entityType = type
             formBuilder.value.entityReference = refValue
             formBuilder.value.line_type = constants.LINE_ELEVATED_HOST_GIFT
         }
         const addDemoClicked = (type,refValue = -1) =>{
             //console.log("addElevatedHostGiftsClicked", type, refValue)
             formBuilder.value.formOpen = true
             formBuilder.value.entityType = type
             formBuilder.value.entityReference = refValue
             formBuilder.value.line_type = constants.LINE_DEMO
         }
         const addProfilingClicked = (type,refValue = -1) =>{
             //console.log("addElevatedHostGiftsClicked", type, refValue)
             formBuilder.value.formOpen = true
             formBuilder.value.entityType = type
             formBuilder.value.entityReference = refValue
             formBuilder.value.line_type = constants.LINE_PROFILING
         }

         const addComponentClicked = (type,refValue = -1) =>{
             //console.log("addComponentClicked", type, refValue)
             formBuilder.value.formOpen = true
             formBuilder.value.entityType = type
             formBuilder.value.entityReference = refValue
             formBuilder.value.line_type = constants.LINE_NORMAL
         }

         const addPartyClickedFromCalendar = (date = new Date()) =>{
             //console.log("addComponentClicked",  date)
             formBuilder.value.formOpen = true
             formBuilder.value.entityType = "party"
             formBuilder.value.preselectedDate = date
         }

         // const addAddress = (date = new Date()) =>{
         //     //console.log("addComponentClicked",  date)
         //     formBuilder.value.formOpen = true
         //     formBuilder.value.entityType = "address"
         //     formBuilder.value.preselectedDate = date
         // }

         return {addElevatedHostGiftsClicked,addHostGiftsClicked, addComponentClicked,addPartyClickedFromCalendar, addDemoClicked, addProfilingClicked, formBuilder, closeForm}
     }
 }
</script>
<style scoped lang="css">
.app-container {
  display: flex;
  flex-direction: column;min-height: 100vh
}
.scroll-disabled {
  overflow: hidden;
  max-height: 100vh;
}
.core-page {
  flex-grow: 1;
  min-height: calc(100vh - 100px);
}
.scroll-disabled .core-page {
  max-height: calc(100vh - 100px);
  overflow: hidden;
}
</style>
<style lang="scss">
  @import "./stylesheets/main.scss";
</style>
<style>
  @font-face {
    font-family: "Rando";
    font-weight: normal;
    font-style: normal;
    src: local("Rando"),
    url(./fonts/Rando-SemiBold.woff2) format("woff2");
  }
</style>
<style>
  @font-face {
    font-family: "Circular Std";
    font-weight: normal;
    font-style: normal;
    src: url(./fonts/CircularStd-Book.woff2) format("woff2");
  }
  @font-face {
    font-family: "Circular Std";
    font-weight: 500;
    font-style: normal;
    src: url(./fonts/CircularStd-Medium.woff2) format("woff2");
  }
  @font-face {
    font-family: "Circular Std";
    font-weight: bold;
    font-style: normal;
    src: url(./fonts/CircularStd-Medium.woff2) format("woff2");
  }
</style>
<style>
  #app {
    font-family: "Circular Std", Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
    background-color: #f5f5f5;
  }

  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }


</style>
